<template>
    <footer class="main-footer">
        
    </footer>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
    }
</script>

<style>

</style>
